import { RigFloorMessage, RigFloorState } from './types'

const getInitialState = (): RigFloorState => {
    return {
        starting: true,
        data: {},
        span: {}
    }
}

export const rigFloorReducer: WidgetReducerType<RigFloorState, RigFloorMessage> = (
    state = getInitialState(),
    message
) => {
    // test for initialState calls
    if (!message) {
        return state
    }

    if (message?.baseline && message?.type !== 'event') {
        return state
    }

    switch (message?.type) {
        case 'start':
            return {
                ...state,
                starting: true,
                data: {}
            }

        case 'event':
            return {
                ...state,
                data: { ...state.data, events: message?.events }
            }

        case 'span':
            return {
                ...state,
                span: { ...state.span, [message?.layer]: message?.events }
            }
    }

    return state
}
